<script>
export default {
  getAccessCode(){
    return this.get('RDAccess',false);
  },
  setAccessCode(v){
    this.set('RDAccess',v,false);
  },
  getLanID(){
    if(this.getLan()=="en") return 1;
    return 2;
  },
  getLan(){    
    if(this.get('MTGAPPLan',false)==null)
    {
      this.set('MTGAPPLan','en',false);
      return 'en';
    }
    return this.get('MTGAPPLan',false);
  },
  setLan(v){
    this.set('MTGAPPLan',v,false);
  },

  setBar(v){
    this.set( 'referralFlag', v, false);
  },
  isBar(){
    return true;
    //  var r =  localStorage.getItem('referralFlag');
    //  if(r==null) return true;
    //  if(r==1) return false;
    //  return true;    
  },

  clear(){
    this.removeUser();
  },
  removeUser(){
    try{
      window.localStorage.clear();
      //localStorage.removeItem('MTGAPPUser');
    }catch(err){
      console.error(err);
    }
  },
  setUser(v){
    this.set('MTGAPPUser', v , false);
  },
  getUser(){
    return this.get('MTGAPPUser', false);
  },
  setSiteID(v){
    this.set('MTGAPPSiteID', v,false);
  },
  getSiteID(){
    return this.get('MTGAPPSiteID',false);
  },
  setAppID(v){
    this.set("MTGAPPAppID",v, false);
  },
  getAppID(){
    return this.get('MTGAPPAppID',false);
  },
  setSiteConf(v){
    this.set( 'MTGAPPSite', v,true);
  },
  getSiteConf(){
    return this.get('MTGAPPSite',true);
  },  
  getAccessToken(){
    return localStorage.getItem('AccessToken');
  },
  set(key, value, objectFlag) {
    if (objectFlag) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  },
  get(key, objectFlag) {
    try {
      if (objectFlag) return JSON.parse(localStorage.getItem(key));
      else return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  
};
</script>
